import { AUTH_URL } from '@bn-games/auth-client';
import { DRAND_MIRRORS } from '@bn-games/verifiable-rng';

export interface DiscordUrlMapping {
  prefix: string;
  target: string;
}

/**
 * The activity iframe may only reach discord.com; every other host has to be
 * proxied through a mapped prefix. drand mirror hosts are derived from
 * `DRAND_MIRRORS` rather than repeated so the two lists cannot drift — the
 * prefix is indexed by mirror position, which is what the Developer Portal
 * URL mappings are configured against.
 */
const DRAND_PREFIX_BASE = '/drand-';
export const AUTH_PREFIX = '/auth-worker';
const WS_PREFIX = '/ws-server';

const WS_SERVER_URL: string = (import.meta.env.VITE_WS_SERVER_URL as string | undefined) ?? '';

/** Accepts `ws:` / `wss:` too — `URL` keeps `host` (incl. port) for any scheme. */
function hostOf(url: string): string | null {
  try {
    return new URL(url).host;
  } catch {
    return null;
  }
}

export function drandPrefix(index: number): string {
  return DRAND_PREFIX_BASE + String(index);
}

export function buildUrlMappings(
  authUrl: string = AUTH_URL,
  wsUrl: string = WS_SERVER_URL,
): DiscordUrlMapping[] {
  const mappings: DiscordUrlMapping[] = [];

  DRAND_MIRRORS.forEach((mirror, index) => {
    const host = hostOf(mirror);
    if (host !== null) {
      mappings.push({ prefix: drandPrefix(index), target: host });
    }
  });

  for (const [prefix, url] of [
    [AUTH_PREFIX, authUrl],
    [WS_PREFIX, wsUrl],
  ] as const) {
    const host = hostOf(url);
    if (host !== null) {
      mappings.push({ prefix, target: host });
    }
  }

  return mappings;
}
